import { createStore } from "vuex";

export default createStore({
  state: {
    types: {
      cpu: 'cpu',
      gpu: 'gpu',
      hdd: 'hdd',
      ram: 'ram'
    },
    target: null,
    activeGame: false,
    isWin: false,
    isLose: false,
    isGame: false,
    gameTime: 0
  },
  getters: {
    /*

      7 - 128
      8 - 256
      9 - 512
      10 - 1024
      11 - 2048

      
      Облако для игры в Crysis (12 CPU, 12 GPU, 12 RAM) — спецуровень (?)


      Сервер для майнкрафта (9 CPU, 11 RAM, 9 ROM) -> (8 CPU, 10 RAM, 7 ROM)
      Облако для рендера видеопоздравлений (8 CPU, 10 GPU и 9 RAM) -> (7 CPU, 8 GPU и 8 RAM)
      Сервер для майнинга (9 CPU, 11 GPU, 8 RAM) -> оставляем как есть
      Сервер для Tproger (9 CPU, 9 RAM, 8 ROM) -> (9 CPU, 8 RAM, 8 ROM)
      Сервер для облачного гейминга (10 CPU, 11 GPU, 10 ROM)  -> (9 CPU, 10 GPU, 9 ROM)
      Сервер для 3D-моделирования (11 CPU, 8 GPU, 11 RAM) -> (10 CPU, 8 GPU, 10 RAM)
      Сервер для нейросети (7 CPU, 10 GPU, 10 RAM) -> (7 CPU, 9 GPU, 9 RAM)

      Сервер для майнкрафта - 1/3
      Облако для рендера видеопоздравлений - 1/3
      Сервер для майнинга - 2/3
      Сервер для Tproger - 1/3
      Сервер для облачного гейминга - 2/3
      Сервер для 3D-моделирования  - 2/3
      Сервер для нейросети - 1/3
    */
    targets: state => {
      return [
        {
          key: 0,
          title: 'Сервер для майнкрафта',
          components: [
            {
              type: state.types.ram,
              count: 1024
            },
            {
              type: state.types.hdd,
              count: 128
            },
            {
              type: state.types.cpu,
              count: 256
            },
          ],
          html: 'Сервер для майнкрафта',
          isHard: false,
          level: 1
        },
        {
          key: 1,
          title: 'Облако для рендера видеопоздравлений',
          html: 'Облако для рендера видеопоздравлений',
          components: [
            {
              type: state.types.gpu,
              count: 256
            },
            {
              type: state.types.cpu,
              count: 128
            },
            {
              type: state.types.ram,
              count: 256
            },
          ],
          isHard: false,
          level: 1
        },
        {
          key: 2,
          title: 'Сервер для майнинга',
          html: 'Сервер для майнинга',
          components: [
            {
              type: state.types.gpu,
              count: 2048
            },
            {
              type: state.types.ram,
              count: 256
            },
            {
              type: state.types.cpu,
              count: 512
            },
          ],
          isHard: false,
          level: 2
        },
        {
          key: 3,
          title: 'Сервер для Tproger',
          html: 'Сервер для Tproger',
          components: [
            {
              type: state.types.cpu,
              count: 512
            },
            {
              type: state.types.ram,
              count: 256
            },
            {
              type: state.types.hdd,
              count: 256
            },
          ],
          isHard: false,
          level: 1
        },
        {
          key: 4,
          title: 'Сервер для облачного гейминга',
          html: 'Сервер для облачного гейминга',
          components: [
            {
              type: state.types.gpu,
              count: 1024
            },
            {
              type: state.types.cpu,
              count: 512
            },
            {
              type: state.types.hdd,
              count: 512
            },
          ],
          isHard: false,
          level: 2
        },
        {
          key: 5,
          title: 'Сервер для 3D-моделирования',
          html: 'Сервер для 3D-моделирования',
          components: [
            {
              type: state.types.cpu,
              count: 1024
            },
            {
              type: state.types.gpu,
              count: 256
            },
            {
              type: state.types.ram,
              count: 1024
            },
          ],
          isHard: false,
          level: 2
        },
        {
          key: 6,
          title: 'Сервер для нейросети',
          html: 'Сервер для нейросети',
          components: [
            {
              type: state.types.ram,
              count: 512
            },
            {
              type: state.types.cpu,
              count: 128
            },
            {
              type: state.types.gpu,
              count: 512
            },
          ],
          isHard: false,
          level: 1
        },
        /*{
          key: 8,
          title: 'Демо сервер',
          html: 'Демо сервер',
          components: [
            {
              type: state.types.ram,
              count: 64
            },
            {
              type: state.types.cpu,
              count: 32
            },
            {
              type: state.types.gpu,
              count: 64
            },
          ],
          isHard: true,
          level: 2
        },*/
        {
          key: 7,
          title: 'Сервер для Crysis',
          html: 'Сервер для Crysis',
          components: [
            {
              type: state.types.ram,
              count: 2048
            },
            {
              type: state.types.cpu,
              count: 2048
            },
            {
              type: state.types.gpu,
              count: 2048
            },
          ],
          isHard: true,
          level: 3
        }

      ]
    },
    target: state => {
      return state.target
    },
    isActive: state => {
      return state.activeGame
    },
    isWin: state => {
      return state.isWin
    },
    isLose: state => {
      return state.isLose
    },
    isGame: state => {
      return state.isGame
    },
    isGameTime: state => {
      return state.gameTime
    }
  },
  mutations: {
    SET_TARGET(state, data) {
      state.target = data
    },
    SET_ACTIVE_GAME(state, data) {
      state.activeGame = data
    },
    SET_WIN_STATUS(state, data) {
      state.isWin = data
    },
    SET_LOSE_STATUS(state, data) {
      state.isLose = data
    },
    SET_GAME_STATUS(state, data) {
      state.isGame = data
    },
    SET_GAME_TIME(state) {
      state.gameTime = state.gameTime + 1
    },
    FLUSH_GAME_TIME(state) {
      state.gameTime = 0
    }
  },
  actions: {
    setTarget({ commit, getters }, index) {
      commit('SET_TARGET', getters.targets[index])
    },
    setActiveGame({ commit, getters }, status) {
      commit('SET_ACTIVE_GAME', status)
    },
    setWinStatus({ commit, getters }, status) {
      commit('SET_WIN_STATUS', status)
    },
    setLoseStatus({ commit, getters }, status) {
      commit('SET_LOSE_STATUS', status)
    },
    setGameStatus({ commit, getters }, status) {
      commit('SET_GAME_STATUS', status)
    },
    incrementGameTime({ commit, getters }) {
      commit('SET_GAME_TIME')
    },
    flushGameTime({ commit, getters }) {
      commit('FLUSH_GAME_TIME')
    },
  },
  modules: {},
});
